import { useCreateMutation } from '../../../../../../lib/utils/createMutation';
import ReviewApiV2 from '../../../../../../lib/api/cs/review/ReviewApiV2';
import { UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { showErrorMessages } from '../../util/util';
import { ReviewPointReturnedResponseBodyDto } from '../../../../../../types/api/reviews';
import { ReviewPointRetrievedRequestPayload } from '../../../../../../types/point';
import { POINT } from '../../../../../../constants/queryKeys';

const usePointRetrieveQuery = (): UseMutationResult<
  ReviewPointReturnedResponseBodyDto,
  unknown,
  ReviewPointRetrievedRequestPayload,
  unknown
> => {
  return useCreateMutation<ReviewPointRetrievedRequestPayload, ReviewPointReturnedResponseBodyDto>({
    queryKey: POINT.RETRIEVE,
    apiFunction: (payload) => ReviewApiV2.retrieveReviewPoint(payload),
    onError: (error: AxiosError) => {
      const data = error?.response?.data as { errors?: [] };
      showErrorMessages(data.errors || []);
    },
  });
};

export default usePointRetrieveQuery;
